import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { PATH_AUTH } from '../paths';

export function PrivateRouter({ children }) {
  const accessToken = localStorage.getItem('accessToken');

  if (accessToken === null) {
    return <Navigate to={PATH_AUTH.root} />;
  }

  return children;
}

PrivateRouter.propTypes = {
  children: PropTypes.node,
};
